import React from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import client from "../../helpers/apollo-client";

let DashboardNavDisplay = ({ userId, isPhotoCreator }) => {
    // Not sure why, but useQuery isn't able to find the client from the
    // context if we wrap this with ApolloProvider, so we're just passing
    // it directly.
    const { loading, data } = useQuery(query, {
        variables: {
            userId: userId
        },
        client: client
    });

    if (loading || !data) {
        return null;
    }

    let { userCollections, userUploads } = data;
    let hasActiveIcons = userUploads && userUploads.hasApprovedUploads;

    let items = [];

    if (isPhotoCreator) {
        items.push(
            <li key="photos">
                <a href="#user-photos" className="ui_photo">
                    Photos
                </a>
            </li>
        );
    }

    if (hasActiveIcons) {
        items.push(
            <li key="royalties">
                <a
                    href="#recent-royalties"
                    className="ui_dollar-sign-circle-filled"
                >
                    Royalties
                </a>
            </li>
        );
        items.push(
            <li key="uploads">
                <a href="#user-uploads" className="ui_upload">
                    Uploads
                </a>
            </li>
        );
    }

    if (userCollections && userCollections.collections.length) {
        items.push(
            <li key="collections">
                <a href="#user-collections" className="ui_collections">
                    Collections
                </a>
            </li>
        );
    }

    items.push(
        <li key="kits">
            <a href="#user-kits" className="ui_kit">
                Kits
            </a>
        </li>
    );

    return (
        <nav className="section-nav">
            <ul id="dashboard-nav">{items}</ul>
        </nav>
    );
};

const query = gql`
    query HasCollections($userId: ID) {
        userCollections(limit: 1, userId: $userId) {
            collections {
                name
            }
        }
        userUploads {
            hasApprovedUploads
        }
    }
`;

let DashboardNav = ({ args }) => {
    // Unpack the args from the Django template
    if (!args) {
        return null;
    }
    let { userId, isPhotoCreator = false } = args;
    return (
        <DashboardNavDisplay userId={userId} isPhotoCreator={isPhotoCreator} />
    );
};

export default DashboardNav;
